import React, { useEffect, useState } from "react";
import { blackBackArrowImage, userIconImage } from "../../assets";
import { Redirect, withRouter } from "react-router-dom";
import Reques from "./components/Reques/Reques";
import Timeline from "./components/Timeline/Timeline";
import RequestInformation from "./components/Request-Information/RequestInformation";
import Comments from "./components/Comments/Comments";
import { CircularProgress } from "@material-ui/core";
import { invokeApi } from "../../bl_libs/invokeApi";
import WorkTime from "./components/Work-Time/WorkTime";
import { useSockets } from "../../Context/Context-Sockets/ContextSockets";

function RequestDetails(props) {
  const { handleRefreshChatList } = useSockets();

  const [requestData, setRequestData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const fetchRequestDetails = (type) => {
    let requestObj = {
      path: "/api/sale_team/sale_team_request_detail",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_id: `${props.match.params.requestId}`,
    };

    requestObj["postData"] = postData;

    if (type === "comment") {
    } else {
      setIsLoading(true);
    }
    invokeApi(requestObj).then((res) => {
      console.log("RESPONSE", res);
      if (res.code === 200) {
        if (res.request.request_status === 2) {
          props.history.goBack();
          return;
        }
        //for refresh chat
        //when ever request details is fetched
        //so we have always updated chat list
        handleRefreshChatList();
        //manage feedback status for indivisual App
        //Based on res.status is 0 or 1,
        //if status===0 then feedback is pending move to timeline status 7
        //if  status===1 it means feedback given move to timeline status 8
        if (res.request.request_timeline_status === 8) {
          res = {
            ...res,
            request: {
              ...res.request,
              request_timeline_status: res.status === 0 ? 7 : 8,
            },
          };
        }
        setRequestData(res);
        setIsLoading(false);
      } else {
      }
    });
  };

  useEffect(() => {
    fetchRequestDetails();
  }, []);

  if (isLoading) {
    return (
      <section id="content-wrapper" className="content-wrapper rating-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Request Page</span>
          </p>
          <div className="container-fluid">
            <div className="Circular-Progress">
              <CircularProgress />
            </div>
          </div>
        </div>
      </section>
    );
  }
  return (
    <>
      <section id="content-wrapper" className="content-wrapper rating-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />
            <span>Request Page</span>
          </p>
          <div className="rating-wrapper mt-40 mt-m-30">
            <div className="row">
              <div className="col-sm-12 col-12 col-md-5 col-xl-4">
                <Reques
                  requestData={requestData}
                  fetchRequestDetails={fetchRequestDetails}
                />
                {requestData.request.request_timeline_status > 5 &&
                  requestData.request.move_time && (
                    <WorkTime requestData={requestData} />
                  )}
                <Timeline requestData={requestData} />
              </div>
              <div className="col-sm-12 col-12 col-md-7 col-xl-8 mt-m-30">
                <RequestInformation
                  requestData={requestData}
                  fetchRequestDetails={fetchRequestDetails}
                />
                <Comments
                  requestData={requestData}
                  fetchRequestDetails={fetchRequestDetails}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default withRouter(RequestDetails);
